import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-attachment-tag',
  templateUrl: './attachment-tag.component.html',
  styleUrls: ['./attachment-tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AttachmentTagComponent {
  @Input() public text = null;
}
